import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Box } from '@mui/material';
import { Delete, Edit, Save, Cancel } from '@mui/icons-material';

export const ActionButtons = ({ 
  isEditing, 
  onEdit, 
  onSave, 
  onCancel, 
  onDelete,
  disabled = false
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      {isEditing ? (
        <>
          <IconButton 
            color="primary" 
            onClick={onSave} 
            size="small"
            disabled={disabled}
          >
            <Save />
          </IconButton>
          <IconButton 
            onClick={onCancel} 
            size="small"
            disabled={disabled}
          >
            <Cancel />
          </IconButton>
        </>
      ) : (
        <>
          <IconButton 
            color="primary" 
            onClick={onEdit} 
            size="small"
            disabled={disabled}
          >
            <Edit />
          </IconButton>
          <IconButton 
            color="error" 
            onClick={onDelete} 
            size="small"
            disabled={disabled}
          >
            <Delete />
          </IconButton>
        </>
      )}
    </Box>
  );
};

ActionButtons.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};